export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref15187.1e68bbd4.jpg";